import { Injectable } from '@angular/core';
import { EvkHttpService, EvkResponseType } from '@evomatik/evk-common';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CadenaOriginalService {

  constructor(private http: EvkHttpService) {}

  public getCadenaOriginal(idDiligencia: string) {

    const request = {
      id: '',
      data: {
          idDiligencia: idDiligencia,
          hash: "",
          username: "",
          numeroSerieCertificado: '',
          fechaVigenciaCertificado: ''
      },
  };
    
    return this.http.post<EvkResponseType<any>>(`/seaged-diligencias-service/generacion-cadena`, request).pipe(
        map(response => response.data)
    );
  }

}
